// FormMode says whether the form on the page may change the application.
// The control-edit route sets readOnly when a case officer opens it to read.
// Attributes that call the API by themselves (applicant-name, application-tag)
// check it, since nothing else stops them in a read-only view.
export class FormMode {
  readOnly = false;
}
